import { GamepadVariantIcon } from './GamepadVariantIcon';

/**
 * author: Austin Andrews
 * id A4DB98F5-FFD6-4F36-BB90-1B06AB202096
 * name gamepad-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gamepad-variant.svg
 * tags
 * - Gaming / RPG 
 */
export const ControllerVariantIcon = GamepadVariantIcon;
export default ControllerVariantIcon